// ModalInteractionTypes
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_PREVIOUS_ITEM = 'MODAL_PREVIOUS_ITEM';
export const MODAL_NEXT_ITEM = 'MODAL_NEXT_ITEM';

// ModalInteractionMethods
export const MODAL_BUTTON_CLICK = 'MODAL_BUTTON_CLICK';
export const MODAL_KEY_PRESS = 'MODAL_KEY_PRESS';
export const MODAL_SWIPE = 'MODAL_SWIPE';

// ModalTypes
export const OUTFIT_GALLERY_MODAL = 'OUTFIT_GALLERY_MODAL';
